// extracted by mini-css-extract-plugin
export default {"list":"menuItems_list__Z7MSw","intelligent-basket":"menuItems_intelligent-basket__eiDYv"};